import { gql } from '@apollo/client';
import Fragments from './fragments';
import CommonFragments from 'features/common/fragments';

export const EXCHANGE_RATE_UPDATED = gql`
  subscription exchangeRateUpdated {
    exchangeRateUpdated {
      exchangeRate {
        ...exchangeRateItem
      }
      headers {
        ...messageHeaders
      }
    }
  }
  ${Fragments.exchangeRateItem}
  ${CommonFragments.messageHeaders}
`;
